import { render } from "./ReceivingAddressEdit.vue?vue&type=template&id=23e2216f&scoped=true"
import script from "./ReceivingAddressEdit.vue?vue&type=script&lang=js"
export * from "./ReceivingAddressEdit.vue?vue&type=script&lang=js"

import "./ReceivingAddressEdit.vue?vue&type=style&index=0&id=23e2216f&scoped=true&lang=less"

import exportComponent from "/home/huiwen/TeamCity/buildAgent/work/78c9eac71a3ca1e9/webs/pdam-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e2216f"]])

export default __exports__